import React, { useEffect } from "react";
import { WORDS } from "../lib/tokiPonaData";
import { Html } from "./tokiPonaUi";

/* ============================================================
   o kama sona — tap-a-word translation popover
   A small affordance for lesson questions: wrap a toki pona word in
   <TapWord> and it becomes tappable, opening one shared <WordPopover>
   with the word's gloss + note. Words not in WORDS (particles, stray
   punctuation-only tokens) render as plain, non-tappable text.
   ============================================================ */

// Strip anything but letters, so punctuation riding along a token
// ("seme?") still resolves to its WORDS entry ("seme") for lookup while
// the original token is what's displayed.
export const wordKey = (tok) => (tok || "").replace(/[^a-zA-Z]/g, "");

// `word` is the WORDS key to look up; `children` (defaulting to `word`)
// is what's rendered. `onTap` is called with the word and the tapped
// element's bounding rect so the caller can position the shared popover.
export const TapWord = ({ word, onTap, className = "", children }) => {
  const entry = WORDS[word];
  if (!entry) return <>{children ?? word}</>;
  return (
    <span
      className={`tapword ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        onTap(word, e.currentTarget.getBoundingClientRect());
      }}
    >
      {children ?? word}
    </span>
  );
};

// The one shared popover. `tap` is `{ word, left, top }` (already
// positioned relative to the lesson app's container) or null when closed.
export const WordPopover = ({ tap, onClose }) => {
  useEffect(() => {
    if (!tap) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [tap, onClose]);

  if (!tap) return null;
  const entry = WORDS[tap.word];
  if (!entry) return null;
  return (
    <>
      <div className="tapword-backdrop" onClick={onClose} />
      <div
        className="tapword-pop"
        style={{ left: tap.left, top: tap.top }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tapword-pop-word">{tap.word}</div>
        <div className="tapword-pop-gloss">{entry.g}</div>
        <Html className="notes" html={entry.n} />
      </div>
    </>
  );
};
